import { useState, useEffect } from 'react';
import s from './Hero.module.css';

const ROLES = [
  'Full-Stack Developer',
  'Founder & CEO',
  'React Engineer',
  'Node.js Expert',
  'Tech Partner',
];

const STACK = ['React.js', 'Node.js', 'MongoDB', 'AWS', 'TypeScript', 'Docker'];

const STATS = [
  { icon: '⚡', val: '8+',  lbl: 'Years Experience' },
  { icon: '🚀', val: '50+', lbl: 'Projects Shipped'  },
  { icon: '🤝', val: '15+', lbl: 'Happy Clients'     },
];

export default function Hero() {
  const [roleIdx, setRoleIdx] = useState(0);
  const [roleVisible, setRoleVisible] = useState(true);

  useEffect(() => {
    const t = setInterval(() => {
      setRoleVisible(false);
      setTimeout(() => {
        setRoleIdx(i => (i + 1) % ROLES.length);
        setRoleVisible(true);
      }, 300);
    }, 2800);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="about" className={s.hero} aria-label="Hero">
      {/* ── LEFT ── */}
      <div className={s.left}>
        <div className={`${s.status} fade-up d1`}>
          <span className={s.statusDot} />
          <span className={s.statusText}>Available for new projects</span>
        </div>

        <h1 className={`${s.name} fade-up d2`}>
          Yosry
          <span className={s.nameLine2}>Mlika.</span>
        </h1>

        <div className={`${s.role} fade-up d3`}>
          <span className={s.rolePrefix}>I'm a </span>
          <span
            className={s.roleVal}
            style={{
              opacity:   roleVisible ? 1 : 0,
              transform: roleVisible ? 'translateY(0)' : 'translateY(6px)',
              transition: 'all .3s ease',
            }}
          >
            {ROLES[roleIdx]}
          </span>
          <span className={s.cursor} />
        </div>

        <p className={`${s.desc} fade-up d4`}>
          8+ years building scalable digital products across healthcare,
          education, IoT &amp; e-commerce. Founder of{' '}
          <strong className={s.strong}>Next IT Era</strong>.
        </p>

        <div className={`${s.ctas} fade-up d5`}>
          <a href="#projects" className={s.ctaMain}>
            <span>View My Work</span>
            <span className={s.arrow}>↗</span>
          </a>
          <a href="#contact" className={s.ctaSec}>
            <span>Get In Touch</span>
          </a>
        </div>

        <div className={`${s.social} fade-up d6`}>
          <a href="mailto:yosry@nextitera.com" className={s.socialLink}>✉ Email</a>
          <div className={s.socialDiv} />
          <a href="https://linkedin.com/in/yosrymlika" target="_blank" rel="noreferrer" className={s.socialLink}>in LinkedIn</a>
          <div className={s.socialDiv} />
          <span className={s.socialLink} style={{ cursor: 'default' }}>🌍 EN · FR · AR</span>
        </div>
      </div>

      {/* ── RIGHT ── */}
      <div className={s.right}>
        <div className={s.ring} aria-hidden="true" />

        <div className={s.statsGrid}>
          {STATS.map(({ icon, val, lbl }, i) => (
            <div key={lbl} className={`${s.card} fade-up`} style={{ animationDelay: `${0.2 + i * 0.12}s` }}>
              <div className={s.cardIcon}>{icon}</div>
              <div className={s.cardVal}>{val}</div>
              <div className={s.cardLbl}>{lbl}</div>
            </div>
          ))}

          {/* Location card */}
          <div className={`${s.card} fade-up`} style={{ animationDelay: '.56s' }}>
            <div className={s.cardIcon}>📍</div>
            <div className={s.cardValSm}>Dubai<br />UAE</div>
            <div className={s.locRow}>
              <span className={s.locDot} />
              <span className={s.locTxt}>Working globally</span>
            </div>
          </div>

          {/* Tech stack — full width */}
          <div className={`${s.card} ${s.cardWide} fade-up`} style={{ animationDelay: '.68s' }}>
            <div className={s.stackLabel}>Core Stack</div>
            <div className={s.stackPills}>
              {STACK.map(t => <span key={t} className={s.stackPill}>{t}</span>)}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className={s.scrollHint} aria-hidden="true">
        <span className={s.scrollTxt}>Scroll</span>
        <div className={s.scrollLine} />
      </div>
    </section>
  );
}